import {hot} from "react-hot-loader/root";
import React, {FC} from "react";
import moment from "moment";
import AssistantApolloWrapper from "./AssistantApolloWrapper";
import AssistantRoutes from "./AssistantRoutes";
import {AssistantThemeProvider} from "./AssistantThemeContext";
import {LastUpdatedProvider} from "./LastUpdatedContext";

const AssistantApp: FC = () => {
    moment.locale("de");

    return (
        <AssistantApolloWrapper>
            <AssistantThemeProvider>
                <LastUpdatedProvider>
                    <AssistantRoutes />
                </LastUpdatedProvider>
            </AssistantThemeProvider>
        </AssistantApolloWrapper>
    );
};

export default hot(AssistantApp);

